import { useState } from "react";
import { getUltimaUbicacionPerforadoraByFecha } from "../../services/justificacion";

export function useGetUltimaUbicacionPerforadoraByFecha() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async (idMaquina, fechaInicio, horaInicio) => {
    try {
      setLoading(true);
      setError(null);

      const result = await getUltimaUbicacionPerforadoraByFecha(idMaquina, fechaInicio, horaInicio);

      if (result.status === "success") {
        setData(result.data.ultimaUbicacion);
      } else {
        setError(result.message);
      }
    } catch (err) {
      setError("Ha ocurrido un error al intentar obtener los datos");
    } finally {
      setLoading(false);
    }
  }

  return { 
    ultimaUbicacionPerforadora: data, 
    getUltimaUbicacionPerforadora: fetchData,
    loadingUltimaUbicacionPerforadora: loading, 
    errorUltimaUbicacionPerforadora: error 
  };
}
